import { gql, useMutation } from '@apollo/client';
import { useOnboardingActions } from '@app/context/OnboardingStateMachineContext';
import { useNavigation } from '@app/hooks/useNavigation';
import { useHistory } from 'react-router-dom';

const LOGOUT_USER = gql`
  mutation LogoutUser {
    logoutUser
  }
`;

export interface UserLogoutResult {
  logoutUser: boolean;
}

export interface UserLogoutOptions {
  skipRedirect?: boolean;
}

export function useUserLogoutMutation(options?: UserLogoutOptions) {
  const { purgeNavigation } = useNavigation();
  const { reset: resetOnboarding } = useOnboardingActions();
  const history = useHistory();
  return useMutation<UserLogoutResult>(LOGOUT_USER, {
    update(cache) {
      cache.evict({});
      cache.gc();
      if (!options?.skipRedirect) {
        window.location.href = '/';
      } else {
        // Clean up state without reload when skipping redirect
        purgeNavigation();
        resetOnboarding();
      }
    },

    onCompleted(data, clientOptions) {},
  });
}
